import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bannerMessageTextClassName } from "../shared/typography-responsive";
import { cn } from "../utils";
import { successBannerVariants } from "./success-banner.styles";
/**
 * SuccessBanner component - Displays success messages in a styled banner
 *
 * @example
 * ```tsx
 * <SuccessBanner message="Your email has been recovered. Enter your password to login." />
 * ```
 */
export function SuccessBanner({ message, className, testID, }) {
    return (_jsxs("output", { className: cn(successBannerVariants(), "bg-success-container rounded-2xl min-h-[40px] p-4", className), "data-testid": testID, children: [_jsx("div", { className: "flex-shrink-0 w-5 h-5", children: _jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", "aria-hidden": "true", children: [_jsx("circle", { cx: "10", cy: "10", r: "10", className: "fill-on-success-container" }), _jsx("path", { d: "M6 10L9 13L14 7", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] }) }), _jsx("span", { className: cn(bannerMessageTextClassName, "text-on-success-container"), children: message })] }));
}
//# sourceMappingURL=SuccessBanner.js.map